import { formatDate } from '@angular/common';

import { formats } from '@environment';

export function formatReportDate(value: string | Date, format: string = formats.reportDate): string {
  if (!value) {
    return null;
  }

  return formatDate(value, format, 'en-US', 'GMT');
}
